import { createDeltaReducer, handleDeltaReducer } from "shared/reduxUtils"
import * as Actions from "./actions"

const initState = {
  isReferralDrawerOpen: false,
  currentReferralToEdit: null,
  ...createDeltaReducer("getAllReferralsResponse"),
  ...createDeltaReducer("createReferralResponse"),
  ...createDeltaReducer("getReferralDetailsResponse"),
  ...createDeltaReducer("saveReferralCoverResponse"),
  ...createDeltaReducer("updateReferralStatusResponse"),
}

export default function referralDashboard(state = initState, action) {
  switch (action.type) {
    case Actions.getAllReferralsAction.REQUEST:
    case Actions.getAllReferralsAction.FAILURE:
    case Actions.getAllReferralsAction.SUCCESS: {
      return {
        ...state,
        ...handleDeltaReducer(
          state,
          action,
          Actions.getAllReferralsAction,
          "getAllReferralsResponse"
        ),
      }
    }

    case Actions.createReferralAction.REQUEST:
    case Actions.createReferralAction.FAILURE:
    case Actions.createReferralAction.SUCCESS: {
      return {
        ...state,
        ...handleDeltaReducer(
          state,
          action,
          Actions.createReferralAction,
          "createReferralResponse"
        ),
      }
    }

    case Actions.getReferralDetailsAction.REQUEST:
    case Actions.getReferralDetailsAction.FAILURE:
    case Actions.getReferralDetailsAction.SUCCESS: {
      return {
        ...state,
        ...handleDeltaReducer(
          state,
          action,
          Actions.getReferralDetailsAction,
          "getReferralDetailsResponse"
        ),
      }
    }

    case Actions.saveReferralCoverAction.REQUEST:
    case Actions.saveReferralCoverAction.FAILURE:
    case Actions.saveReferralCoverAction.SUCCESS: {
      return {
        ...state,
        ...handleDeltaReducer(
          state,
          action,
          Actions.saveReferralCoverAction,
          "saveReferralCoverResponse"
        ),
      }
    }

    case Actions.updateReferralStatusAction.REQUEST:
    case Actions.updateReferralStatusAction.FAILURE:
    case Actions.updateReferralStatusAction.SUCCESS: {
      return {
        ...state,
        ...handleDeltaReducer(
          state,
          action,
          Actions.updateReferralStatusAction,
          "updateReferralStatusResponse"
        ),
      }
    }

    case Actions.toggleReferralDrawerAction.type: {
      const { bool, data } = action.data
      return {
        ...state,
        isReferralDrawerOpen: bool,
        currentReferralToEdit: data,
      }
    }

    case Actions.setReferralFilterQueryAction.type: {
      return {
        ...state,
        filterQueries: action.data,
      }
    }

    default: {
      return state
    }
  }
}
